<template>
  <SectionTopBanner
    :title="title"
    title-class="max-w-full lg:max-w-[528px] text-center lg:text-left mt-8 lg:mt-0 mx-4 lg:mx-0"
    :subtitle="subtitle"
    :img="img"
    title-img-type="world"
    :has-background="false"
    :img-sizes="{lg: [672, 339 ], xs: [327, 164]}"
  />
</template>

<script>
import SectionTopBanner from '@design-system/section/top-banner/top-banner'
import staticData from './static-data'
// import HomeBannerNavigations from '~/components/pages/home/top-banner/top-banner-navigations.vue'
export default {
  name: 'WorldTopBanner',
  components: {
    SectionTopBanner
  },
  data () {
    return {
      ...staticData
    }
  }
}
</script>

<style lang="scss" scoped>
.top-banner {
  @apply container flex flex-wrap
  flex-wrap-reverse sm:flex-nowrap
  items-center sm:justify-center justify-start;
}
</style>
